import { parse } from "util/parsers";
import { when } from "util/support";
import type { WithOnboardingStep, WithRequestedChangeFileds } from "features/ecommerce/types";

export const useRequestedChanges = () => {
    const parseRequestedChangeFields = <TOutput extends unknown>({ requestedChangeFields }: WithRequestedChangeFileds): TOutput => (
        parse(String(requestedChangeFields))
    );

    const serializeRequestedChangeFields = ({ requestedChangeFields }: Partial<WithRequestedChangeFileds>) => when(
        requestedChangeFields,
        JSON.stringify(requestedChangeFields),
        null
    );

    const withRequestedChangeFields = <
        TStep extends object,
        TRequestedChanges extends unknown
    >(stepData: WithOnboardingStep<TStep>): WithOnboardingStep<TStep> => ({
        ...stepData,
        requestedChangeFields: parseRequestedChangeFields<TRequestedChanges>(stepData)
    });

    return {
        withRequestedChangeFields,
        parseRequestedChangeFields,
        serializeRequestedChangeFields
    };
};

export default useRequestedChanges;
